import React from "react";
import PropTypes from "prop-types";

const SettingsMenu = ({ user, showDirectDeposit, activeSection, scrollToSection }) => {
	let settingsMenu = user.getAccountMenu();
	if (!showDirectDeposit) {
		settingsMenu = settingsMenu ? settingsMenu.filter(item => item.id !== "directdeposit") : [];
	}

	return (
		<div id="my-account-settings-menu">
			<For
				each="item"
				of={settingsMenu}
			>
				<button
					key={`settings-btn-${item.id}`}
					type="button"
					className={`btn btn-block text-left${activeSection === item.id ? " active" : ""}`}
					onClick={scrollToSection(item.id)}
				>
					<i className={item.icon} />
					{item.title}
				</button>
			</For>
		</div>
	);
};

SettingsMenu.propTypes = {
	activeSection: PropTypes.string.isRequired,
	scrollToSection: PropTypes.func.isRequired,
	user: PropTypes.object,
	showDirectDeposit: PropTypes.bool,
};

SettingsMenu.defaultProps = {
	user: { getAccountMenu: () => [] },
	showDirectDeposit: false,
};

export default SettingsMenu;
